import { BuzzfeedQuizComponent } from "./contents/buzzfeed_quiz/buzzfeed_quiz";
import { QuizCompletionCallback } from "./contents/buzzfeed_quiz/buzzfeed_quiz.controller";
import { GoalFeedbackPostBody } from "./contents/goal_feedback/goal_feedback.component";
import { ImageInfographic } from "./contents/image-infographic/image-infographic.component";
import { PaginatedArticle } from "./contents/paginated-article/paginated-article.component";
import SingleImageView from "./contents/single-image-view/single-image-view.component";
import { UnsupportedPost } from "./contents/unsupported-post";
import { YoutubeVideo } from "./contents/youtube-video";
import {
  BasicImagePost,
  BuzzfeedQuizPost,
  GoalFeedbackPost,
  PaginatedArticlePost,
  PostData,
  YoutubeVideoPost,
} from "./post.models";

export interface PostBodyProps<PostType extends PostData> {
  data: PostType;
  onQuizCompleted?: QuizCompletionCallback;
}

export function PostBody<T extends PostData>(props: PostBodyProps<T>) {
  let data;
  switch (props.data.type) {
    case "single-image-view":
      data = props.data as any as BasicImagePost;
      return <SingleImageView {...data} />;
    case "image-infographic":
      data = props.data as any as BasicImagePost;
      return <ImageInfographic {...data} />;
    case "youtube-video":
      data = props.data as any as YoutubeVideoPost;
      return <YoutubeVideo {...data} />;
    case "buzzfeed-quiz":
      data = props.data as any as BuzzfeedQuizPost;
      return (
        <BuzzfeedQuizComponent
          {...data}
          onQuizCompleted={props.onQuizCompleted!}
        />
      );
    case "paginated-article":
      data = props.data as any as PaginatedArticlePost;
      return <PaginatedArticle {...data} />;
    case "goal-feedback":
      data = props.data as any as GoalFeedbackPost;
      return <GoalFeedbackPostBody {...data} />;
    default:
      return <UnsupportedPost {...props.data} />;
  }
}
